require('./bootstrap');

// import Swiper from 'swiper/bundle';
// window.Swiper = Swiper;

import Splide from '@splidejs/splide';
window.Splide = Splide;
import '@splidejs/splide/css';

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
    duration: 1200,
});

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

import 'flowbite';
